import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { TextButton } from '@shared/ui';
import * as st from './styles.module.scss';

interface Props {
  onReset: () => void;
  onConfirm: () => void;
}

export const FilterMobileActions = ({ onReset, onConfirm }: Props): JSX.Element => {
  const { module } = useModuleByCodeParam();

  const resetBtnIsDisabled = module?.code === 'library';

  return (
    <div className={st.actions}>
      <TextButton
        className={st.throwOff}
        size="medium"
        onClick={onReset}
        disabled={resetBtnIsDisabled}
      >
        Сбросить
      </TextButton>
      <TextButton size="medium" onClick={onConfirm}>
        Готово
      </TextButton>
    </div>
  );
};
